The batch of signals to be sent.

Up to 100 signals can be sent in a single request.
